<template>
  <div>
    <p v-if="canCreateEmergencyRequest">
      <button class="btn btn-sm btn-outline-gray mb-1" @click="$emit('emergency-request-create')">
        <i class="fa fa-arrow-up"></i> Đề nghị cấp cứu
      </button>
    </p>

    <p v-if="canApproveRequestEmergency">
      <button class="btn btn-sm btn-outline-gray mb-1 mr-1" @click="$emit('emergency-request-approve')">
        <i class="fa fa-check"></i> Tiếp nhận cấp cứu
      </button>
    </p>

    <p v-if="canCancelRequestEmergency">
      <button class="btn btn-sm btn-outline-gray mb-1 mr-1" @click="$emit('emergency-request-cancel')">
        <i class="fa fa-times"></i> Hủy đề nghị cấp cứu
      </button>
    </p>

    <p v-if="canUnfollowOrRequestCommunityCare">
      <button class="btn btn-sm btn-outline-gray mb-1 mr-1" @click="$emit('unfollow')">
        <i class="fa fa-check"></i> Nhập viện và ngừng theo dõi
      </button>
      <button class="btn btn-sm btn-outline-gray mb-1" @click="$emit('emergency-community-care-request-create')">
        <i class="fa fa-arrow-down"></i> Chuyển về cộng động
      </button>
    </p>

    <p v-if="canApproveCommunityCareRequest">
      <button class="btn btn-sm btn-outline-gray mb-1" @click="$emit('emergency-community-care-request-approve')">
        <i class="fa fa-check"></i> Nhận chăm sóc
      </button>
    </p>

    <p v-if="canCancelCommunityCareRequest">
      <button class="btn btn-sm btn-outline-gray mb-1" @click="$emit('emergency-community-care-request-cancel')">
        <i class="fa fa-times"></i> Hủy đề nghị chăm sóc cộng đồng
      </button>
    </p>
  </div>
</template>

<script>
import {EMERGENCY_STATE, getEmergencyState} from '../utils/emergencyUtils';

function getId(value) {
  if (!value) return null;
  return typeof value === 'object' ? value._id : value;
}

function canUserSendEmergencyRequest(userRole, userGroup, benhNhan) {
  if (userRole && typeof userRole !== 'string') throw new TypeError('userRole must be a string or null');
  if (userGroup && typeof userGroup !== 'string') throw new TypeError('userGroup must be a string or null');
  if (typeof benhNhan !== 'object') throw new TypeError('benhNhan must be an object');
  return (
    ['owner', 'bac-sy-truong-nhom', 'bac-sy-pho-nhom'].includes(userRole) &&
    [getId(benhNhan.group), '610e362ce7aef55208d80670', '610e25b9d8ba7b532cc750a8'].includes(userGroup)
  );
}

function canUserReceiveEmergencyRequest(userRole) {
  if (typeof userRole !== 'string') throw new TypeError('userRole must be a string');
  return ['owner', 'cap-cuu'].includes(userRole);
}

export default {
  props: {
    benhNhan: {
      type: Object,
      required: true,
      validator: benhNhan => !!getId(benhNhan),
    },
  },
  computed: {
    emergencyState() {
      return getEmergencyState(this.benhNhan);
    },
    canCreateEmergencyRequest() {
      return (
        this.benhNhan.tier >= 'nc3' &&
        [EMERGENCY_STATE.NORMAL, EMERGENCY_STATE.COMMUNITY_CARE].includes(this.emergencyState) &&
        canUserSendEmergencyRequest(this.$store.state.user.role, getId(this.$store.state.user.group), this.benhNhan)
      );
    },
    canApproveRequestEmergency() {
      return (
        [EMERGENCY_STATE.NORMAL__EMERGENCY_REQUESTED, EMERGENCY_STATE.COMMUNITY_CARE__EMERGENCY_REQUESTED].includes(
          this.emergencyState
        ) && canUserReceiveEmergencyRequest(this.$store.state.user.role)
      );
    },
    canCancelRequestEmergency() {
      return (
        [EMERGENCY_STATE.NORMAL__EMERGENCY_REQUESTED, EMERGENCY_STATE.COMMUNITY_CARE__EMERGENCY_REQUESTED].includes(
          this.emergencyState
        ) &&
        canUserSendEmergencyRequest(this.$store.state.user.role, getId(this.$store.state.user.group), this.benhNhan)
      );
    },
    canUnfollowOrRequestCommunityCare() {
      return (
        [EMERGENCY_STATE.EMERGENCY].includes(this.emergencyState) &&
        canUserReceiveEmergencyRequest(this.$store.state.user.role)
      );
    },
    canApproveCommunityCareRequest() {
      return (
        [EMERGENCY_STATE.EMERGENCY__COMMUNITY_CARE_REQUESTED].includes(this.emergencyState) &&
        canUserSendEmergencyRequest(this.$store.state.user.role, getId(this.$store.state.user.group), this.benhNhan) &&
        getId(this.$store.state.user) === getId(this.benhNhan.requestCommunityCareSeniorDoctorUser)
      );
    },
    canCancelCommunityCareRequest() {
      return (
        [EMERGENCY_STATE.EMERGENCY__COMMUNITY_CARE_REQUESTED].includes(this.emergencyState) &&
        canUserReceiveEmergencyRequest(this.$store.state.user.role)
      );
    },
  },
};
</script>
